export default function remPlan() {
    // 基础基准值是375px
    const baseW = 375;
    // 当前的基准值
    let nowBase = 375;
    const winW = window.innerWidth;
    const baseSize = baseW / 100;
    const padMinMax = [422.752, 750];
    let useSize = 0;

    if (winW >= padMinMax[0] && winW <= padMinMax[1]) {
        // 平板
        nowBase = 422.752;
        useSize = (window.innerWidth / nowBase) * baseSize;
    } else if (winW > padMinMax[1]) {
        // pc 固定值
        useSize = baseW / 100;
    } else {
        // 手机
        useSize = (window.innerWidth / nowBase) * baseSize;
    }
    document.documentElement.style.fontSize = `${useSize}px`;
}
